import type { ReferentialCode } from "../types"

export const getFilterYearOptions = ({
  nbPreviousYearsToDisplay = 1,
  baseYear = new Date().getFullYear(),
}: { nbPreviousYearsToDisplay?: number; baseYear?: number }) => {
  const years = [baseYear]
  years.push(
    ...Array.from(
      { length: nbPreviousYearsToDisplay },
      (_, i) => baseYear - (i + 1),
    ),
  )
  const yearOptions: ReferentialCode<number>[] = years.map((year) => ({
    label: year.toString(),
    code: year,
  }))

  return yearOptions
}
